import {Component, OnInit} from '@angular/core';
import {MapService} from './map.service';
import {SharedService} from '../../services/sharedService';

@Component({
  selector: "map-preview",
  template: `
    <div style="margin: 15px 0px;">
        <div>
          Current Location LatLon: {{locationLatLng}}
        </div>
        <div>
            Selected Building Id: {{selectedBuildingDetails | json}}
        </div>
        <div>
            Selected Feature geoJSON: {{geoJSON | json}}
        </div>
        <label>BBOX</label>
        <input [(ngModel)]="bbox" style="width: 550px">
        <br/>
        search by ID
        <input [(ngModel)]="buildingId" style="width: 550px">
        <button (click)="searchById()">find</button>
        <div>
            <input [(ngModel)]="streetId" style="width: 150px">
            <input [(ngModel)]="houseNumber" style="width: 50px">
            <button (click)="addMarker()">Add Marker</button>
        </div>
        <br/>
        <app-map [height]="'70vh'"
                  [registered]="false" [withAttributes]="false"
                  [findMyLocation]="true" [bbox]="bbox" (selectedBuildingDetails)="selectedBuildingDetails = $event" (mapReady)="buildingId=undefined; featureId=undefined"
                  (myLocationLatLng)="locationLatLng =$event" [buildingId]="buildingId" [showBuildingLayer]="true" (selectedFeatureGeoJSON)="geoJSON = $event"
                  [addPolygon]="true"
                  [editBuilding]="false" [editFeature]="false" [editLot]="false"
                  [loadBuildings]="false"
                  [layers]="layers" [featureId]="featureId"
        ></app-map>
<!--        <app-map *ngIf="buildingId" [height]="'70vh'" [registered]="true" [findMyLocation]="true" [bbox]="bbox" (selectedBuildingDetails)="selectedBuildingDetails = $event"-->
<!--                 (myLocationLatLng)="locationLatLng =$event" [buildingId]="buildingId" (selectedFeatureGeoJSON)="geoJSON = $event" [addPolygon]="true"></app-map>-->
    </div>
  `
})
export class MapPreviewComponent implements OnInit{
  // buildingId_
  childLayer = {layer:"district_dev", parentId: "6595048d481c3568d37ce75d"}
  featureId = undefined
  layers = this._.getAllLayers()
  buildingId = undefined
  selectedBuildingDetails
  bbox
  locationLatLng
  geoJSON

  streetId
  houseNumber  = "33a"
  addedFeatureId
  featureGeoJson = {
    "type": "Polygon",
    "coordinates": [
      [
        [
          -3.30722652,
          5.13494027
        ],
        [
          -3.30728285,
          5.13497031
        ],
        [
          -3.30731749,
          5.13490501
        ],
        [
          -3.30726116,
          5.13487498
        ],
        [
          -3.30722652,
          5.13494027
        ]
      ]
    ]
  }

  constructor(private mapService: MapService,
              private _:SharedService) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      // this.buildingId = 145449
      // this.featureId = 367
    }, 100);
    // setTimeout(() => {
    //   this.layers = ['district_dev'];
    // }, 5000);
  }

  searchById() {
    // this.buildingId = null
    // setTimeout(()=>{
    //   this.buildingId = 145449
    // }, 100)
  }

  addMarker(){
    let body = {
      streetId: +this.streetId,
      houseNumber: this.houseNumber,
      geoJson: this.geoJSON
    }
    if (!this.addedFeatureId)
      this.mapService.addBuilding$(body).subscribe( building => {
        alert('Added building ' + building.id)
        this.addedFeatureId = building.id
        console.log(body, building)
      })
    else
      this.mapService.updateBuilding$(this.addedFeatureId, body).subscribe( building => {
        alert('Updated building ' + building.id)
        this.addedFeatureId = building.id
        console.log(body, building)
      })

  }
}
